const MuiListItemText = {
  styleOverrides: {
    root: {
      margin: 0
    },
    primary: {
      fontSize: '18px',
      lineHeight: '24px'
    }
  }
};
export default MuiListItemText;